<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        塾一覧
      </template>

      <template v-slot:content>
        <v-row class="mb-0 pb-0">
          <v-col cols="2">
            <v-text-field
              v-model="searchSchool"
              label="塾名"
              color="secondary"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="customerId"
              label="お客様No."
              color="secondary"
            />
          </v-col>
          <v-col cols="6" class="d-flex">
            <!--
            <v-btn class="mt-5 ml-3 mb-3 download-button" small color="#4a81aa" dark
              >csvダウンロード</v-btn
            >
            -->
            <v-btn
              class="mt-5 ml-3 create-button"
              small
              color="#4a81aa"
              dark
              @click.stop="create"
              >新規作成</v-btn
            >
          </v-col>
        </v-row>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="filteredSchools"
            disable-pagination
            hide-default-footer
            mobile-breakpoint=10
          >
            <template #[`item`]="{ item }">
              <tr :style="item.isOutOfService ? 'background: #bababa' : ''">
                <td class="pa-4 text-start">{{item.name}}</td>
                <td class="pa-4 text-start">{{item.code}}</td>
                <td class="pa-4 text-start">{{item.tel}}</td>
                <td class="pa-4 text-start">{{item.email}}</td>
                <td align="center">
                  <v-btn icon @click.stop="edit(item)">
                    <v-icon small dark>
                      mdi-cog-outline
                    </v-icon>
                  </v-btn>
                </td>
                <td align="center">
                  <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
                    <v-icon dark>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-base-card>

    <v-confirm-dialog
      ref="confirm"
      title="塾削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import VBaseCard from "@/components/molecules/BaseCard";
import VConfirmDialog from '@/components/atoms/ConfirmDialog'

export default {
  components: {
    VBaseCard,
    VConfirmDialog,
  },
  data() {
    return {
      searchSchool: "",
      customerId: "",
      page: 1,
      headers: [
        { text: "塾名", align: "start", value: "name", sortable: false, class: 'list-th' },
        { text: "お客様No.", align: "start", value: "code", sortable: false, class: 'list-th' },
        { text: "電話番号", align: "start", value: "tel", sortable: false, class: 'list-th' },
        { text: "メールアドレス", align: "start", value: "email",  sortable: false, class: 'list-th' },
        { text: "編集", align: "center", value: "edit", sortable: false, class: 'list-th' },
        { text: "削除", align: "center", value: "delete", sortable: false, class: 'list-th' },
      ],
      schools: [],
      showUploadArea: false,
      dropzoneOptions: {
          url: 'localhost:3000:',
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          headers: { "My-Awesome-Header": "header value" },
          dictDefaultMessage:"<i class='mdi mdi-cloud-upload'></i>ファイルをアップする"
      },
      deletedSchool: {},
    }
  },

  async mounted() {
    await this.getSchools()
  },

  computed: {
    filteredSchools() {
      return this.schools.filter(
        (school) =>
          school.name.includes(this.searchSchool) &&
          school.code.includes(this.customerId)
      );
    },
    deleteMessage() {
      return `${this.deletedSchool.name} を削除します。よろしいですか。`
    },
  },

  methods: {
    async getSchools() {
      this.loading = true
      const res = await this.$axios('/api/v1/admin/customers')
      this.schools = res.data
      this.loading = false
    },
    openDeleteConfirmDialog(school) {
      this.deletedSchool = school
      this.$refs.confirm.open()
    },
    async confirmDeletion() {
      const url = `api/v1/admin/customers/${this.deletedSchool.id}`
      await this.$axios.delete(url)
      this.$toasted.global.success({ message: `${this.deletedSchool.name}を削除しました` })
      this.getSchools()
    },
    async edit(school) {
      this.$store.commit('school/initialize', {})
      this.$store.commit('school/setSchool', school)
      this.$router.push('/admin/school')
    },
    create() {
      this.$store.commit('school/initialize')
      this.$router.push('/admin/school')
    },
  }
};
</script>

<style lang="stylus" scoped>

th
  font-size: 13px !important
  padding: 0 35px !important
  background-color: #e5e5e5
td
  padding: 0 35px !important

.select
  font-size: 11px !important;

.table-link
  cursor pointer

.textbox
  border: 2px solid #ccc
  border-radius: 4px

.create-button
  position: absolute
  right: 30px

.download-button
  position: absolute
  right: 120px

</style>
